var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.isSpScreen)?_c('SpBoard'):_c('PcBoard')}
var staticRenderFns = []

export { render, staticRenderFns }